import { ca } from '@cian/analytics';

import { TJsonQuery } from '../../../../packages/JsonQuery';

export function trackSuburbanShowSaveSearchClick(sc: TJsonQuery) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'saved_search',
    action: 'open',
    label: 'window',
    sc,
    useLastProducts: true,
  });
}
